import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {AppService, Host, Cart} from "../../../../../common";
import {transition, trigger, useAnimation} from "@angular/animations";
import {createHighlightAnimation} from "../../animations/highlight";

@Component({
  selector: 'app-header',
  standalone: false,
  templateUrl: './app-header.html',
  styleUrls: ['./app-header.scss'],
  animations: [
    trigger('countChange', [
      transition(':increment',
        useAnimation(createHighlightAnimation({shadowColor: '#ffc107'}))
      )
    ])
  ]
})
export class AppHeader implements OnInit, OnDestroy {

  @Input() host: Host;
  @Input() cart: Cart;
  canClose: boolean;
  ordersEnabled: boolean;

  constructor(
    private appService: AppService,
  ) {
    this.ordersEnabled = appService.getOrdersEnabled();
    this.canClose = appService.canClose();
  }

  ngOnInit() {
    document.querySelector('body').classList.add('has-fixed-top')
  }

  ngOnDestroy() {
    document.querySelector('body').classList.remove('has-fixed-top')
  }

  closeApp(): void {
    this.appService.closeApp();
  }
}
